import React from 'react';
import { connect } from 'react-redux';

import { createSelector } from 'reselect';

import ClosingDateListingCard from '../../components/resaleClosingDashboard/ClosingDateListingCard';
import { LISTING_OFFER_CHANNELS } from '../../constants/ListingOfferConstants';
import { IListingOfferBasic } from '../../declarations';
import { EventTrackingFn } from '../../declarations';
import layoutWrapper from '../../hocs/layoutWrapper';
import resaleClosingDashboardIndexLoader from '../../hocs/resaleClosingDashboardIndexLoader';
import * as resaleClosingDashboardActions from '../../store/resaleClosingDashboard/actions';
import * as resaleClosingDashboardSelectors from '../../store/resaleClosingDashboard/selectors';

import './ResaleClosingDashboardIndexStyle.less';

export interface IResaleClosingDashboardIndexProps {
  listingOffers: IListingOfferBasic[];
  trackEvent: EventTrackingFn;
}

export class ResaleClosingDashboardIndex extends React.PureComponent<
  IResaleClosingDashboardIndexProps,
  {}
> {
  public componentDidMount() {
    const { trackEvent } = this.props;

    trackEvent('resale-closing-dashboard', 'load', 'index');
  }

  public render(): JSX.Element {
    const { listingOffers } = this.props;

    const description = listingOffers.some(
      listingOffer => listingOffer.channel === LISTING_OFFER_CHANNELS.direct,
    )
      ? 'Properties you are in contract with'
      : 'Properties your clients are now in contract with';

    return (
      <div className="resale-closing-dashboard-index">
        <div className="container">
          <div className="index-subtitle">Buy With Opendoor</div>
          <h1 className="index-heading">
            Buyer
            {"'"}s Closing Dashboard
          </h1>
          <div className="index-description">{description}</div>
          <div className="row">
            {listingOffers.map(listingOffer => (
              <div
                className="col-xs-8 col-xs-offset-2 col-sm-offset-0 col-sm-6 col-md-4"
                key={listingOffer.id}
              >
                <a href={`/closing-dashboard/${listingOffer.id}`}>
                  <ClosingDateListingCard
                    closeOfEscrowDate={listingOffer.close_of_escrow}
                    listing={listingOffer.listing}
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = createSelector(
  [resaleClosingDashboardSelectors.listingOffers],
  (listingOffers: IListingOfferBasic[]) => ({
    listingOffers,
  }),
);

const mapDispatchToProps = {
  trackEvent: resaleClosingDashboardActions.trackEvent,
};

export default layoutWrapper(
  resaleClosingDashboardIndexLoader(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    )(ResaleClosingDashboardIndex),
  ),
  { footerType: 'FULL' },
);
